import { useKnockSlackClient as E } from "../context/KnockSlackProvider.mjs";
import { useMemo as u, useEffect as x } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import I from "swr/infinite";
import { useKnockClient as L } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "fast-deep-equal";
import "date-fns";
import "swr";
const N = 1e3, P = 200, g = "private_channel,public_channel", k = "SLACK_CHANNELS";
function A(n, c) {
  return n === 0 ? [k, ""] : c && ["", null].includes(c.next_cursor) ? null : [k, c.next_cursor ?? ""];
}
function v({
  queryOptions: n
}) {
  const c = L(), {
    knockSlackChannelId: C,
    tenantId: _,
    connectionStatus: s
  } = E(), d = (t) => c.slack.getChannels({
    tenant: _,
    knockChannelId: C,
    queryOptions: {
      ...n,
      cursor: t == null ? void 0 : t[1],
      limit: (n == null ? void 0 : n.limitPerPage) || P,
      types: (n == null ? void 0 : n.types) || g
    }
  }), {
    data: l,
    error: i,
    isLoading: e,
    isValidating: a,
    setSize: r,
    mutate: S
  } = I(A, d, {
    initialSize: 0,
    revalidateFirstPage: !1
  }), m = l == null ? void 0 : l.at(-1), f = m === void 0 || !!m.next_cursor, o = u(() => (l ?? []).flatMap((t) => t == null ? void 0 : t.slack_channels).filter((t) => !!t), [l]), h = (n == null ? void 0 : n.maxCount) || N;
  return x(() => {
    s === "connected" && !i && f && !e && !a && o.length < h && r((t) => t + 1);
  }, [o.length, r, f, e, a, h, i, s]), {
    data: o,
    isLoading: e || a,
    refetch: () => S()
  };
}
export {
  v as default
};
//# sourceMappingURL=useSlackChannels.mjs.map
